
import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet';

import { login } from "../db/User";

import { httpPost } from "../services/http";
import { getCommonLDScripts, getLDArticle } from '../services/seo';

const Page = (props) => {
  const { match: { params: { slug } } } = props
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    httpPost('page/get', { slug: slug })
      .then((res) => {
        setLoading(false)
        setData(res.data);
      });
  }, [slug])

  const { title, text, createdAt, updatedAt } = data || {}

  return (
    <>
    <Helmet
      script={[
        ...getCommonLDScripts(),
        getLDArticle({
          name: title,
          description: text,
          createdAt,
          updatedAt,
        }),
      ]}
    >
      <meta name='title' content={title} />
      <meta name='author' content='Xpart' />
      <meta name="robots" content="index,follow" />
      <meta name='theme-color' content='#1a7fc8' />
      <meta name='local' property='og:local' content='uk_UA' />
      <meta name='site_name' property='og:site_name' content={window.location.hostname} />
    </Helmet>
    <div className='section__content' style={{ minHeight: 700 }}>
      {loading && <div className='lmask' />}
      <h1>{title}</h1>
      <div
        style={{ wordBreak: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
    </>
  )
}

function mapStateToProps(state) {
  return {
    translate: state.translate
  }
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ login }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Page)